export const PhotoComponent = ({ photoUrl }: { photoUrl: string }) => {
  return (
    <div className="relative h-48 w-56">
      <img src={photoUrl} alt="Photo" className="rounded-lg border border-black object-cover" />
    </div>
  );
};
